export default __webpack_public_path__ + "static/mode-delegate-dark-5b6d59740db5176a3d846f35b932f880.png";